import { supabase } from '@/lib/supabase';
import type { AdminOrgSummary, PlatformSettings } from '@/lib/types';

/**
 * Admin / platform helpers (Day 9).
 *
 * platform_settings is readable by everyone signed in (so the maintenance
 * banner renders). All writes go through SECURITY DEFINER RPCs that gate on
 * app_is_platform_admin().
 */

export async function getPlatformSettings(): Promise<PlatformSettings | null> {
  const { data, error } = await supabase
    .from('platform_settings')
    .select('*')
    .maybeSingle();
  if (error) throw error;
  return (data ?? null) as PlatformSettings | null;
}

export async function setPlatformMaintenance(
  enabled: boolean,
  message: string | null = null
): Promise<PlatformSettings> {
  const { data, error } = await supabase.rpc('platform_maintenance_set', {
    p_enabled: enabled,
    p_message: message,
  });
  if (error) throw error;
  return data as PlatformSettings;
}

export async function freezeOrg(
  orgId: string,
  reason: string | null = null
): Promise<void> {
  const { error } = await supabase.rpc('org_freeze', {
    p_org_id: orgId,
    p_reason: reason,
  });
  if (error) throw error;
}

export async function unfreezeOrg(orgId: string): Promise<void> {
  const { error } = await supabase.rpc('org_unfreeze', { p_org_id: orgId });
  if (error) throw error;
}

export async function listOrgsSummary(): Promise<AdminOrgSummary[]> {
  const { data, error } = await supabase.rpc('admin_orgs_summary');
  if (error) throw error;
  return (data ?? []) as AdminOrgSummary[];
}
